import config from './config';
const uploadFile = async (blob, fileName = 'upload') => {
    // Crear un formulario para enviar el archivo
    const formData = new FormData();

    // Identificar el tipo MIME del archivo
    const fileType = blob.type || 'application/octet-stream'; // Tipo predeterminado si no hay uno
    const extension = fileType.split('/')[1] || 'bin'; // Obtén la extensión desde el tipo MIME
    const file = new File([blob], `${fileName}.${extension}`, { type: fileType });
    formData.append('file', file);

    try {
        const response = await fetch(config.host_ws + '/api/upload', {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            throw new Error('Error al subir el archivo');
        }

        const data = await response.json();
        console.log('Archivo subido con éxito:', data.url);
        return data.url; // Devuelve la URL del archivo
    } catch (error) {
        console.error('Error subiendo el archivo:', error);
        return null;
    }
};

export const calculateTime = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = Math.floor(totalSeconds % 60);
    const returnedSeconds = totalSeconds < 10 ? `0${seconds}`:seconds;
    return `${minutes}:${returnedSeconds}`;
}

export const getFileType = (url) => {
    const videoExtensions = [".mp4", ".avi", ".mov", ".webm"];
    const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp"];

    const extension = url.split("?")[0].split(".").pop().toLowerCase();

    if (videoExtensions.includes(`.${extension}`)) {
      return "video";
    } else if (imageExtensions.includes(`.${extension}`)) {
      return "image";
    }
    return "unknown";
};


export default  uploadFile ;
